module.exports = __webpack_public_path__ + "media/images/smart_phone/item/kuchi_btn_ov-3f7aec163f740ac669160a80641e109a.gif";